import DateTime from '@ricoh/ria.client.core/plugins/moment';
import { isNull } from '@ricoh/ria.client.core/utils/data/object';

import type { DataValue, DataValueNull } from '~/common/model/api/common';

import { getListDataType } from './_type';

/**
 * Format DataValue.
 *
 * @param {DataValue | DataValueNull} value DataValue.
 * @param {[true: string, false: string]} booleanDisplay Boolean display.
 *
 * @returns {string} Formatted DataValue.
 */
export function formatDataValue(value: DataValue | DataValueNull, [trueDisplay, falseDisplay]: [true: string, false: string]): string {
  if (!value.type || isNull(value.value)) {
    return '';
  }

  const listFieldType = getListDataType(value.type);
  if (listFieldType && Array.isArray(value.value)) {
    return value.value
      .map((item) =>
        formatDataValue(
          {
            type: listFieldType,
            value: item,
          } as DataValue,
          [trueDisplay, falseDisplay],
        ),
      )
      .join(', ');
  }

  switch (value.type) {
    case 'text':
    case 'integer':
    case 'decimal':
    case 'currency': {
      return value.value.toString();
    }

    case 'boolean': {
      return value.value ? trueDisplay : falseDisplay;
    }

    case 'datetime': {
      return DateTime.nullable(value.value)?.format(DateTime.config.format.display.datetime) ?? '';
    }

    case 'date': {
      return (
        DateTime.nullablePattern({
          date: value.value,
        })?.format(DateTime.config.format.display.date) ?? ''
      );
    }

    case 'time': {
      return (
        DateTime.nullablePattern({
          time: value.value,
        })?.format(DateTime.config.format.display.time) ?? ''
      );
    }

    case 'table': {
      return JSON.stringify(value.value);
    }

    default: {
      return '';
    }
  }
}
